import React from 'react';
import { Navigate } from 'react-router-dom';

function readSession(key) {
  return sessionStorage.getItem(key) || localStorage.getItem(key);
}

function clearAuth() {
  sessionStorage.clear();
  localStorage.clear();
}

function ProtectedRoute({ children, allowedRole }) {
  const userId = readSession('userId');
  const role = readSession('role');
  const isAuthenticated = readSession('authenticated');
  const expiresAt = Number(readSession('expiresAt') || 0);

  if (!userId || !isAuthenticated || (expiresAt && Date.now() > expiresAt)) {
    clearAuth();
    return <Navigate to="/" />;
  }

  if (allowedRole && role !== allowedRole) {
    return <Navigate to="/" />;
  }

  return children;
}

export default ProtectedRoute;
